import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import styled,{ injectGlobal }  from 'styled-components';
import { Main, MainContainer, AppProvider, Header, Footer, Hi } from './components';

injectGlobal`
import url("https://fonts.googleapis.com/css?family=Roboto:400,900");
body { 
    margin: 0;
    padding: 0;
    font-size: 20px;
}
`
const MainStyle = styled.main`
width: 100vw;
height: 80vh;
`
class App extends Component{
    render(){
        return(
            <MainStyle>
                 <AppProvider>
                     <Header/>
                        <Switch>
                           <Route exact path="/" component={Main}/>
                           <Route path='/mainpage' component={MainContainer}/>
                           <Route path="/hi" component={Hi}/>
                           <Route render={()=><Redirect to="/hi"/>}/>
                         </Switch>
                      <Footer/>
               </AppProvider>
            </MainStyle>

        )
    }
};

export default App;


// WEBPACK FOOTER //
// ./src/App.js